import { useState, useEffect, useCallback } from 'react';
import { gameStore } from '../store/gameStore';
import { GameState } from '../types';

export function useGameStore(): GameState {
  const [state, setState] = useState<GameState>(gameStore.getState());

  useEffect(() => {
    return gameStore.subscribe(() => {
      setState(gameStore.getState());
    });
  }, []);

  return state;
}

export function useGameActions() {
  return {
    startGame: useCallback(() => gameStore.startGame(), []),
    startPlaying: useCallback(() => gameStore.startPlaying(), []),
    setPhase: useCallback((phase: GameState['phase']) => gameStore.setPhase(phase), []),
    moveToRoom: useCallback((roomId: GameState['currentRoom']) => gameStore.moveToRoom(roomId), []),
    addItem: useCallback((itemId: any) => gameStore.addItem(itemId), []),
    removeItem: useCallback((itemId: any) => gameStore.removeItem(itemId), []),
    hasItem: useCallback((itemId: any) => gameStore.hasItem(itemId), []),
    openPuzzle: useCallback((puzzleId: any) => gameStore.openPuzzle(puzzleId), []),
    closePuzzle: useCallback(() => gameStore.closePuzzle(), []),
    solvePuzzle: useCallback((puzzleId: any) => gameStore.solvePuzzle(puzzleId), []),
    isPuzzleSolved: useCallback((puzzleId: any) => gameStore.isPuzzleSolved(puzzleId), []),
    interactHotspot: useCallback((id: string) => gameStore.interactHotspot(id), []),
    hasInteracted: useCallback((id: string) => gameStore.hasInteracted(id), []),
    showDialog: useCallback((msgs: any) => gameStore.showDialog(msgs), []),
    advanceDialog: useCallback(() => gameStore.advanceDialog(), []),
    dismissDialog: useCallback(() => gameStore.dismissDialog(), []),
    showScreenEffect: useCallback((effect: any) => gameStore.showScreenEffect(effect), []),
    showAcquiredItem: useCallback((itemId: any) => gameStore.showAcquiredItem(itemId), []),
    dismissAcquiredItem: useCallback(() => gameStore.dismissAcquiredItem(), []),
    addMessage: useCallback((msg: string) => gameStore.addMessage(msg), []),
    determineEnding: useCallback((choice: string) => gameStore.determineEnding(choice), []),
    toggleMenu: useCallback(() => gameStore.toggleMenu(), []),
    saveGame: useCallback(() => gameStore.saveGame(), []),
    loadGame: useCallback(() => gameStore.loadGame(), []),
    resetGame: useCallback(() => gameStore.resetGame(), []),
    setBgmVolume: useCallback((v: number) => gameStore.setBgmVolume(v), []),
    setSfxVolume: useCallback((v: number) => gameStore.setSfxVolume(v), []),
  };
}
